
export default function createTime(date: string): string {
  const messageDate = new Date(+date);
  const options: Intl.DateTimeFormatOptions = {
    hour: 'numeric',
    minute: 'numeric',
  };
  return messageDate.toLocaleTimeString(undefined, options)
}
